"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgBrainFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.brain_filled_svg__cls-1{display:none}')),
        React.createElement("path", { className: "brain_filled_svg__cls-1", d: "M0 0h32v32H0z", id: "brain_filled_svg__transparent_box" }),
        React.createElement("g", { id: "brain_filled_svg__FILLED" },
            React.createElement("path", { className: "brain_filled_svg__cls-1", d: "M23 26v1-1zM9 26v0z" }),
            React.createElement("path", { d: "M13 22v-2a2 2 0 002-2v-5.54A6 6 0 0111 14v-2a4 4 0 004-4V5.17a3.49 3.49 0 00-7 .33 4 4 0 00.05.5H8a5 5 0 00-5 5 4.73 4.73 0 00.3 1.66 4.93 4.93 0 00.12 6.8A5.49 5.49 0 018 17v2a3.5 3.5 0 000 7h1v1a3 3 0 006 0v-5.56a3.91 3.91 0 01-2 .56zM23 26h1a3.5 3.5 0 000-7v-2a5.49 5.49 0 014.58 2.46 4.93 4.93 0 00.12-6.8A4.73 4.73 0 0029 11a5 5 0 00-5-5v-.46a3.49 3.49 0 00-7-.25V8a4 4 0 004 4v2a6 6 0 01-4-1.54V18a2 2 0 002 2v2a3.91 3.91 0 01-2-.56V27a3 3 0 006 0v-1z" }))));
}
exports.default = SvgBrainFilled;
//# sourceMappingURL=BrainFilled.js.map